
import { APIService } from "services";

export const tokenAPICALL = async (user, pass) => {
    try {
        const response = await APIService.apiNoAuth().post(`/smlogin`, {
            "username": user,
            "password": pass
        }, {
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Access-Control-Allow-Headers': '*',
                'Access-Control-Allow-Methods': '*'

            }
        })

        if (response && response.status === 200) {
            const data = response.data;
            const now = new Date().getTime();
            const expiryDate = now + data.expires_in;
            return { jwtToken: data.access_token, expiryDate: expiryDate, userData: data.userData };
        } else {
            return null;
        }
    } catch (error) {
        console.log("Login error", error);
        return null;
    }
}
